import { Link } from "react-router-dom";
import { MapPin, Phone, Mail, Facebook, Instagram, Youtube } from "lucide-react";
import { useSettings } from "../../context/SettingsContext";
import { Mandala } from "../Mandala";

export default function Footer() {
  const s = useSettings();
  return (
    <footer className="relative mt-20 bg-[#2a0f0a] text-amber-100 overflow-hidden">
      <Mandala className="absolute -right-20 -top-20 w-80 h-80 text-amber-500/10" />
      <div className="relative max-w-7xl mx-auto px-6 py-14 grid gap-10 md:grid-cols-4">
        <div className="md:col-span-1">
          <div className="flex items-center gap-3 mb-4">
            <img src={s.logo_url} alt="logo" className="h-12 w-12 rounded-full ring-2 ring-amber-400/40" />
            <div className="font-display font-bold text-lg text-amber-50">{s.temple_name || "Sri Mehandipur Balaji Mandir"}</div>
          </div>
          <p className="text-sm text-amber-200/70 leading-relaxed">{s.temple_tagline}</p>
          <div className="flex gap-3 mt-4">
            <a href={s.social?.facebook || "#"} className="p-2 rounded-full bg-amber-900/40 hover:bg-amber-700/50" data-testid="footer-facebook"><Facebook className="w-4 h-4" /></a>
            <a href={s.social?.instagram || "#"} className="p-2 rounded-full bg-amber-900/40 hover:bg-amber-700/50" data-testid="footer-instagram"><Instagram className="w-4 h-4" /></a>
            <a href={s.social?.youtube || "#"} className="p-2 rounded-full bg-amber-900/40 hover:bg-amber-700/50" data-testid="footer-youtube"><Youtube className="w-4 h-4" /></a>
          </div>
        </div>

        <div>
          <h4 className="font-display font-bold text-amber-50 mb-4">Explore</h4>
          <ul className="space-y-2 text-sm text-amber-200/80">
            <li><Link to="/about" className="hover:text-white">About Us</Link></li>
            <li><Link to="/worship/deities" className="hover:text-white">Deities</Link></li>
            <li><Link to="/worship/timings" className="hover:text-white">Darshan & Timings</Link></li>
            <li><Link to="/seva" className="hover:text-white">Seva & Pooja</Link></li>
            <li><Link to="/happenings/events" className="hover:text-white">Events & Festivals</Link></li>
            <li><Link to="/community/gallery" className="hover:text-white">Gallery</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="font-display font-bold text-amber-50 mb-4">Help & Legal</h4>
          <ul className="space-y-2 text-sm text-amber-200/80">
            <li><Link to="/help/faq" className="hover:text-white">FAQ</Link></li>
                    <li><Link to="/booking/lookup" className="hover:text-white">View / Cancel Booking</Link></li>

            <li><Link to="/legal/privacy-policy" className="hover:text-white">Privacy Policy</Link></li>
            <li><Link to="/legal/terms-conditions" className="hover:text-white">Terms & Conditions</Link></li>
            {/* <li><Link to="/legal/cancellation-refund" className="hover:text-white">Cancellation & Refund</Link></li> */}
            <li><Link to="/legal/disclaimer" className="hover:text-white">Disclaimer</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="font-display font-bold text-amber-50 mb-4">Reach Us</h4>
          <ul className="space-y-3 text-sm text-amber-200/80">
            <li className="flex gap-2"><MapPin className="w-4 h-4 shrink-0 mt-0.5 text-amber-400" /> {s.address}</li>
            <li className="flex gap-2"><Phone className="w-4 h-4 shrink-0 text-amber-400" /> {s.phone}</li>
            <li className="flex gap-2"><Mail className="w-4 h-4 shrink-0 text-amber-400" /> {s.email}</li>
          </ul>
        </div>
      </div>
      <div className="relative border-t border-amber-900/50 py-5 text-center text-xs text-amber-300/60 px-6">
        © {new Date().getFullYear()} {s.temple_name}. All rights reserved. · Content & imagery are placeholders pending temple approval.
        <span className="mx-2">·</span><Link to="/admin/login" className="hover:text-amber-200" data-testid="footer-admin-link">Staff Login</Link>
      </div>
    </footer>
  );
}
